/*
 *---------------------------------------------------
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *---------------------------------------------------
 */
export enum MessageType {
  ERROR = "error",
  SUCCESS = "success",
}
export type Message = {
  type: MessageType;
  message: string;
  [extraProps: string]: any;
};

export const SKIP_MESSAGE_SNACKBAR = "skipMessageSnackbar";
export const REASON_CLICK_AWAY = "clickaway";
